export function LoadingState({ dark = false, cards = 4, rows = 3, label = "Loading" }) {
  const base = dark ? "bg-slate-800" : "bg-slate-200";
  const panel = dark ? "border-slate-800 bg-slate-900" : "border-border bg-white";
  return (
    <div role="status" aria-live="polite" aria-label={label} className="animate-pulse" data-testid="loading-state">
      <span className="sr-only">{label}…</span>
      <div className="grid grid-cols-2 gap-3 md:grid-cols-4">
        {Array.from({ length: cards }).map((_, index) => (
          <div key={index} className={`border p-4 ${panel}`}>
            <div className={`h-8 w-20 ${base}`} />
            <div className={`mt-3 h-3 w-28 ${base}`} />
          </div>
        ))}
      </div>
      <div className={`mt-5 border p-4 ${panel}`}>
        {Array.from({ length: rows }).map((_, index) => (
          <div key={index} className={`h-4 ${index ? "mt-4" : ""} ${base}`} style={{ width: `${88 - index * 9}%` }} />
        ))}
      </div>
    </div>
  );
}

export function ErrorState({ dark = false, message = "We could not load this information.", onRetry }) {
  return (
    <div role="alert" className={`border p-6 text-center ${dark ? "border-red-500/30 bg-red-500/10 text-red-200" : "border-red-200 bg-red-50 text-red-700"}`}>
      <p className="text-sm font-medium">{message}</p>
      {onRetry && <button type="button" onClick={onRetry} className="mt-3 border border-current px-3 py-1.5 text-xs font-semibold">Try again</button>}
    </div>
  );
}
